import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export default function Genese() {
  const { locale } = useLang();
  const isFr = locale === "fr";

  return (
    <main data-testid="genese-page">
      <section
        id="genese"
        className="relative max-w-4xl mx-auto px-6 lg:px-10 py-20 lg:py-28"
        data-testid="genese-section"
      >
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="label-overline mb-5 text-center">— La Genèse</p>
          <h1
            className="font-display text-3xl lg:text-5xl text-amber-glow text-center tracking-tight leading-tight mb-3"
            data-testid="genese-title"
          >
            {isFr ? "D'où vient FACOW 360 ?" : "Where does FACOW 360 come from?"}
          </h1>
          <p className="text-center text-xs font-mono-tech uppercase tracking-[0.3em] text-[#00F0FF]/80 mb-12">
            {isFr ? "L'origine de FACOW 360" : "The origin of FACOW 360"}
          </p>
        </motion.div>

        <div className="space-y-6 text-slate-300 leading-relaxed text-base lg:text-lg" data-testid="genese-content">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay: 0.0 }}
            className="first-letter:font-display first-letter:text-5xl first-letter:lg:text-6xl first-letter:text-amber-glow first-letter:float-left first-letter:mr-3 first-letter:leading-none first-letter:mt-1"
          >
            On ne peut ramener quelqu'un vers la lumière que si l'on connaît parfaitement l'anatomie du gouffre. Mon parcours n'a rien d'une théorie apprise sur les bancs d'une école. C'est une transformation radicale.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            Pour comprendre la puissance de FACOW360, il faut regarder la réalité en face : la clarté la plus absolue naît souvent du chaos le plus total. Avant de devenir un canal, j'ai navigué dans la noirceur. J'ai connu les erreurs de trajectoire, l'enfermement intérieur et les impasses où l'énergie s'épuise. J'ai habité cet espace lourd où la fréquence vitale est coupée. Ce n'était pas une simple erreur de parcours, c'était mon laboratoire.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay: 0.15 }}
          >
            Ma renaissance a commencé par la maîtrise de la matière. Pendant dix ans, j'ai imposé à mon corps la rigueur absolue du fitness et de la nutrition. J'ai nettoyé mon organisme en profondeur pour rebâtir mon propre temple, fibre par fibre, afin qu'il redevienne un instrument solide, capable de soutenir et de porter une vibration supérieure.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="border-l-2 border-[#D4AF37]/50 pl-6 italic text-slate-200"
          >
            Aujourd'hui, je refuse la fragmentation du bien-être. FACOW360 unit la Géobiologie, la Cuisine Vivante et le Magnétisme en fédérant un cercle de thérapeutes et une boutique spécialisée pour créer une synergie inédite. Mon but n'est pas de réparer des pièces détachées, mais de réaccorder votre instrument dans sa totalité. Une seule vision, un seul flux : l'Unité à 360°.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.0, delay: 0.3 }}
          className="mt-14 flex items-center justify-center gap-4"
        >
          <span className="h-px w-16 bg-[#D4AF37]/40" />
          <span className="font-display tracking-[0.5em] text-[#D4AF37]/80 text-sm">
            ᚠ ᚢ ᚦ ᚨ ᚱ ᚲ
          </span>
          <span className="h-px w-16 bg-[#D4AF37]/40" />
        </motion.div>
      </section>
    </main>
  );
}
